module.exports = __webpack_public_path__ + "img/resized-APP-0016-2.b95657f7.png";